export default {
  LOCAL: 'localhost',
  SANDBOX: 'sandbox',
  STAGING: 'staging',
  PRODUCTION: 'production',
};
